import { Button, Modal } from "react-bootstrap";
import ThemedModal from "../../../../../@ui/Modal/ThemedModal";

interface CensusYearModalProps {
  show: boolean;
  message: string;
  onFitMap: () => void;
  onClose: () => void;
}

const CensusYearModal = ({
  show,
  message,
  onFitMap,
  onClose,
}: CensusYearModalProps) => {
  const handleFitMap = () => {
    onFitMap();
    onClose();
  };

  return (
    <ThemedModal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Census Year</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleFitMap}>
          Fit Map
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default CensusYearModal;
